module.exports = __webpack_public_path__ + "static/media/a3_levels_20-29.55855106.png";